import React, { useState } from "react";
import LegacyAgreementForm1 from "./LegacyAgreementForm1";
import LegacyAgreementForm3 from "./LegacyAgreementForm3";
import LegacyAgreementForm2 from "./LegacyAgreementForm2";
import { Stepper } from "@mantine/core";
import { useDispatch, useSelector } from "react-redux";

function CreateNewObligation() {
  const FORM_STEPS = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
  };

  const [uiConfigs, setUiConfigs] = useState({
    currentStep: FORM_STEPS.STEP_1,
  });

  const [details, setDetails] = useState({
    agreementId: 0,
    local: false,
    secondParty: "",
    parentAgreementId: 0,
    typeOfAgreement: "",
    endDate: "",
    jobOrder: "",
    brandName: "",
  });

  const [file, setFile] = useState(null);

  const [legacyAgreementFormValue, setLegacyAgreementFormValue] = useState({
    typeOfAgreementData: [],
    titleOfAgreementData: [],
    typeOfAgreement: null,
    titleOfAgreement: null,
    jobOrder: "",
    agreementValue: 0,
    relationshipType: "",
    relationshipWith: "",
    dueDateOfContract: null,
    dateOfContract: null,
    noOfMonths: null,
    noOfDays: null,
    noOfYears: null,
    reminderTimeInDays: "15",
    location: null,
    businessUnit: "1",
    mapRegion: "1",
  });

  return (
    <>
      <div>
        <Stepper
          color="#1b6f8d"
          active={uiConfigs.currentStep}
          onStepClick={(step) => {
            setUiConfigs({
              ...uiConfigs,
              currentStep: step,
            });
          }}
          breakpoint="sm"
          style={{ paddingRight: "10px" }}
        >
          <Stepper.Step label="Contract Details">
            <LegacyAgreementForm1
              legacyAgreementFormValue={legacyAgreementFormValue}
              setLegacyAgreementFormValue={setLegacyAgreementFormValue}
              uiConfigs={uiConfigs}
              setUiConfigs={setUiConfigs}
              saveAgreement={() => {}}
              setFile={setFile}
              setDetails={setDetails}
              file={file}
            />
          </Stepper.Step>

          <Stepper.Step allowStepSelect={true} label="Create">
            <LegacyAgreementForm2
              uiConfigs={uiConfigs}
              setUiConfigs={setUiConfigs}
              file={file}
              setFile={setFile}
              details={details}
            />
          </Stepper.Step>
          <Stepper.Step allowStepSelect={true} label="Obligation List">
            <LegacyAgreementForm3
              uiConfigs={uiConfigs}
              setUiConfigs={setUiConfigs}
              details={details}
            />
          </Stepper.Step>
        </Stepper>
      </div>
    </>
  );
}

export default CreateNewObligation;
